import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import WizardShell from '../components/wizard/WizardShell';
import { useMyTenant, isAdminRole } from '../hooks/useMyTenant';

export default function OnboardingPage() {
  const navigate = useNavigate();
  const { myTenant, loading } = useMyTenant();

  useEffect(() => {
    if (!loading && myTenant && !isAdminRole(myTenant.role)) {
      navigate('/projects', { replace: true });
    }
  }, [loading, myTenant, navigate]);

  if (loading || !myTenant) {
    return (
      <div className="flex min-h-screen" style={{ background: 'var(--bg)' }}>
        <Sidebar />
        <main className="flex-1 px-8 py-6">
          <div className="animate-pulse space-y-4">
            <div className="h-6 rounded w-48" style={{ background: 'var(--surface-alt)' }} />
            <div className="h-4 rounded w-80" style={{ background: 'var(--surface-alt)' }} />
            <div className="h-32 rounded-xl" style={{ background: 'var(--surface-alt)' }} />
          </div>
        </main>
      </div>
    );
  }

  if (!isAdminRole(myTenant.role)) {
    return null; // redirect in-flight
  }

  return (
    <div className="flex min-h-screen" style={{ background: 'var(--bg)' }}>
      <Sidebar />

      <main className="flex-1 overflow-auto">
        {/* Top bar */}
        <div
          className="px-8 py-5 border-b sticky top-0 z-10"
          style={{ background: 'var(--surface)', borderColor: 'var(--border)' }}
        >
          <h1
            style={{
              fontFamily: 'var(--font-display)',
              fontSize: 24,
              fontWeight: 700,
              color: 'var(--text)',
            }}
          >
            Organisation Setup
          </h1>
          <p style={{ fontFamily: 'var(--font-body)', fontSize: 14, color: 'var(--text-secondary)', marginTop: 2 }}>
            Complete your setup to unlock all BluePrint features for{' '}
            <strong>{myTenant.tenantName}</strong>.
          </p>
        </div>

        {/* Wizard card */}
        <div className="px-8 py-8" style={{ maxWidth: 780 }}>
          <div
            className="rounded-xl border shadow-sm"
            style={{
              background: 'var(--surface)',
              borderColor: 'var(--border)',
              padding: 'var(--space-6)',
            }}
          >
            <WizardShell tenantId={myTenant.tenantId} />
          </div>
        </div>
      </main>
    </div>
  );
}
